/*/
	@title: Bootstrap Custom Build
	@author: Stephen Ginn
	@date: 2026-09-29

	Bundles only the Bootstrap components the site uses and exposes them as window.bootstrap. Dropdown pulls in Popper on its own. Add a component here before using it in markup or init.js.
/*/

import Carousel from 'bootstrap/js/src/carousel.js';
import Collapse from 'bootstrap/js/src/collapse.js';
import Dropdown from 'bootstrap/js/src/dropdown.js';
import Modal from 'bootstrap/js/src/modal.js';
import ScrollSpy from 'bootstrap/js/src/scrollspy.js';
import Tab from 'bootstrap/js/src/tab.js';

window.bootstrap = {
	Carousel,
	Collapse,
	Dropdown,
	Modal,
	ScrollSpy,
	Tab
};
